


import { Card, InlineStack, Icon, Text, BlockStack, InlineGrid } from '@shopify/polaris';
import { ChevronRightMinor } from '@shopify/polaris-icons';
import React from 'react';
import { DI, DIProps } from '../../../../../Core';
import { useTranslation } from 'react-i18next';

interface Props extends DIProps {
    syncNecessaryInfo: () => void;
    syncConnectorInfo: (props: any, shop_url?: string | null, updateCurrentShop?: boolean, updateStepStatus?: React.Dispatch<React.SetStateAction<string>>) => void;
    syncProfileInfo: () => void;
    loginStatus: () => void;
    syncServices: () => void;
}

const TemplateInformation = (props: Props): JSX.Element => {
    const { t } = useTranslation();
    const getCategoryPath = () => {
        let modifiedPath: any = ""
        if (props?.location?.state?.categoryInfo?.displayPath.length == 1) {
            modifiedPath = <Text as='span'>{props?.location?.state?.categoryInfo?.displayPath[0]}</Text>
        }
        else {
            modifiedPath = props?.location?.state?.categoryInfo?.displayPath?.map((pathName: string, index: number) => {
                return (
                    <InlineStack key={index} gap="100">
                        <Text as='span' variant='headingMd' fontWeight='regular'>{pathName}</Text>
                        {props?.location?.state?.categoryInfo?.displayPath.length != index + 1 ? <Icon source={ChevronRightMinor} tone="base" /> : <></>}
                    </InlineStack>
                );
            });
        }
        return modifiedPath;
    }

    return (
        <Card padding="500">
            <InlineStack align='space-between' wrap={true} gap='400' blockAlign='start'>
                <BlockStack gap="400">
                    <InlineGrid gap="300" columns={['oneThird', 'twoThirds']}>
                        <Text as='p' tone='subdued' variant="bodyLg">{t("Template Name")}</Text>
                        <Text as='p' variant='headingMd' fontWeight='regular'>{props?.location?.state?.templateName}</Text>
                    </InlineGrid>
                    <InlineGrid gap="300" columns={['oneThird', 'twoThirds']}>
                        <Text as='p' tone='subdued' variant="bodyLg">{t("Category Assigned")}</Text>
                        <InlineStack gap={"200"} align='start'>{getCategoryPath()}</InlineStack>
                    </InlineGrid>
                    <InlineGrid gap="300" columns={['oneThird', 'twoThirds']}>
                        <Text as='p' tone='subdued' variant="bodyLg">{t("Products Assigned")}</Text>
                        <Text as='p' variant='headingMd' fontWeight='regular'>{props?.location?.state?.count}</Text>
                    </InlineGrid>
                </BlockStack>
                {/* <Badge icon={InfoMinor} tone='info' size='large'>Mapping required for 50 Attributes</Badge> */}
            </InlineStack>
        </Card>
    );
}

export default DI(TemplateInformation);